import { Alert } from '@shared/components';
import type { OutcomeCard } from '../utils/invoiceBalance';

function OutcomeRow({ label, amount }: { label: string; amount: string }) {
    return (
        <div className="flex items-baseline justify-between gap-4">
            <dt className="text-sm text-mp-muted">{label}</dt>
            <dd className="text-lg font-semibold text-mp-foreground">{amount}</dd>
        </div>
    );
}

export function InvoiceOutcomeCard({ outcome }: { outcome: OutcomeCard }) {
    if (outcome.kind === 'unavailable') {
        return (
            <Alert variant="error" role="note">
                {outcome.reason}
            </Alert>
        );
    }

    if (outcome.kind === 'pot_total') {
        return (
            <div className="rounded-lg bg-mp-background p-3">
                <dl className="space-y-1">
                    <OutcomeRow label="Claimed from pot" amount={outcome.claimed} />
                    <OutcomeRow label="Dealer absorbs" amount={outcome.absorbed} />
                </dl>
            </div>
        );
    }

    return (
        <div className="rounded-lg bg-mp-background p-3">
            {outcome.kind === 'loading' ? (
                <p className="text-sm text-mp-muted">{outcome.reason}</p>
            ) : (
                <dl className="flex items-baseline justify-between gap-4">
                    <dt className="text-sm text-mp-muted">{outcome.label}</dt>
                    <dd className="text-lg font-semibold text-mp-foreground">{outcome.amount}</dd>
                </dl>
            )}
        </div>
    );
}
